import { UserRole } from "tm-shared/types";

export interface InfoTabContractsCapabilities {
    canAddContract: boolean;
    onlyActiveContracts: boolean;
}

export const getInfoTabContractsCapabilities = (
    role: UserRole | null,
): InfoTabContractsCapabilities => ({
    canAddContract: role === UserRole.Sv,
    onlyActiveContracts: role === UserRole.Ta || role === UserRole.Md,
});
